export const webClientId = '506464832665-bp2c5f0b5llkeu6huqa8l7dr7cumcllm.apps.googleusercontent.com'